var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organization-load-guard',{attrs:{"organization-id":_vm.organizationId}},[_c('public-packet',{attrs:{"packet-id":_vm.packetId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }